const env = process.env.REACT_APP_ENVIRONMENT || 'LOCAL';

export const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (env === 'PRODUCTION'
    ? 'https://postpop.kr'
    : env === 'SANDBOX'
      ? 'https://test-dudu.kro.kr'
      : 'http://localhost:3000');
